import { axios } from "../connection/ConnectionHandler";
import { API } from "../constants/api";
import { keyBy } from "lodash";
import {
    ADD_NEW_CONSULTINVOICEPLANNING,
    DELETE_CONSULTINVOICEPLANNING,
    CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING,
    SET_CONSULTINVOICEPLANNING_LIST,
    SHOW_NOTIFICATION,
    UPDATE_CONSULTINVOICEPLANNING,
} from "../constants";
import { formatConsultInvoicePlannings } from "./settingsActionsUtils";

/* CONSULTINVOICEPLANNING LIST */
export const fetchConsultInvoicePlannings = () => {
    return async (dispatch) => {
        const response = await axios
            .get(API.consultInvoicePlannings.list)
            .then((response) => {
                const consultInvoicePlannings = formatConsultInvoicePlannings(response.data);
                dispatch({
                    type: SET_CONSULTINVOICEPLANNING_LIST,
                    payload: keyBy(consultInvoicePlannings, "_id"),
                });
                return response.status;
            })
            .catch((err) => err);
        return response;
    };
};

// CONSULTINVOICEPLANNINGS
export const createConsultInvoicePlanning = (newConsultInvoicePlanning) => {
    return async (dispatch) => {
        dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
        const response = await axios
            .post(API.consultInvoicePlannings.create, newConsultInvoicePlanning)
            .then((response) => {
                const consultInvoicePlanning = formatConsultInvoicePlannings(response.data);
                dispatch({ type: ADD_NEW_CONSULTINVOICEPLANNING, payload: consultInvoicePlanning });
                dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "success",
                        message: "Planificación facturas consultoría creado con éxito.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const updateConsultInvoicePlanning = (updatedConsultInvoicePlanning) => {
    return async (dispatch) => {
        dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
        const response = await axios
            .put(`${API.consultInvoicePlannings.edit}${updatedConsultInvoicePlanning && updatedConsultInvoicePlanning._id}`, updatedConsultInvoicePlanning)
            .then((response) => {
                const consultInvoicePlanning = formatConsultInvoicePlannings(response.data);
                dispatch({ type: UPDATE_CONSULTINVOICEPLANNING, payload: consultInvoicePlanning });
                dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Planificación facturas consultoría actualizado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};

export const deleteConsultInvoicePlannings = (Ids) => {
    return async (dispatch) => {
        dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
        const response = await axios
            .delete(`${API.consultInvoicePlannings.delete}`, { data: Ids })
            .then((response) => {
                dispatch({ type: DELETE_CONSULTINVOICEPLANNING, payload: Ids });
                dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
                dispatch({
                    type: SHOW_NOTIFICATION,
                    payload: {
                        show: true,
                        status: "info",
                        message: "Planificación facturas consultoría eliminado.",
                    },
                });
                return response && response.status;
            })
            .catch((err) => {
                dispatch({ type: CONSULTINVOICEPLANNING_FORM_TOOGLE_LOADING });
                return err;
            });
        return response;
    };
};
